import { useSendGiftCardTransactionReceiptQuery } from 'api/giftcard-service/giftcard-service';
import { useSendOrderTransactionReceiptQuery } from 'api/ordering-service/ordering-service';
import { PAYMENT_TYPES } from 'appConstants';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

type customerTypes = {
  email: string;
};

export type SendReceiptShowInMenuTypes = {
  orderId?: string;
  giftcardTxId?: string;
  scanToPayTxId?: string;
  type?: string;
  customer?: customerTypes;
  showInMenu?: boolean;
  transactionId?: string;
};

export const useSendReceipt = (args: SendReceiptShowInMenuTypes) => {
  const { t } = useTranslation();
  const [orderTransactionId, setOrderTransactionId] = useState<
    undefined | string
  >();
  const [giftCardTransactionId, setGiftCardTransactionId] = useState<
    undefined | string
  >();

  const {
    orderId,
    giftcardTxId,
    transactionId,
    type,
    customer: { email } = {},
  } = args;

  const { isFetching: sendOrderTxtFetching } =
    useSendOrderTransactionReceiptQuery(
      {
        id: orderTransactionId,
        fulfilledNotification: email
          ? t('TransactionsDataGrid.actions.sendReceipt.notification.text', {
              email,
            })
          : t('page.salesreport.toast.sendReceipt'),
        extTransactionId: transactionId,
      },
      { skip: !orderTransactionId },
    );

  const { isFetching: sendGiftCardTxtFetching } =
    useSendGiftCardTransactionReceiptQuery(
      {
        id: giftCardTransactionId,
        fulfilledNotification: t(
          'TransactionsDataGrid.actions.sendReceipt.notification.text',
          {
            email,
          },
        ),
        extTransactionId: transactionId,
      },
      { skip: !giftCardTransactionId },
    );

  const trigger = async () => {
    if (type === PAYMENT_TYPES.ORDER) setOrderTransactionId(orderId);
    else setGiftCardTransactionId(giftcardTxId);
  };

  const isFetching = sendOrderTxtFetching || sendGiftCardTxtFetching;

  useEffect(() => {
    if (isFetching) {
      setOrderTransactionId(undefined);
      setGiftCardTransactionId(undefined);
    }
  }, [isFetching, setGiftCardTransactionId, setOrderTransactionId]);

  return {
    trigger,
    isFetching,
    setGiftCardTransactionId,
    setOrderTransactionId,
  };
};
